import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom-v5-compat';

import { getCurrentUser } from 'src/reducers/Reporting.slice';

export const AuthenticatedReportingRoute = ({
  redirectTo,
}: {
  redirectTo: string;
}) => {
  const currentUser = useSelector(getCurrentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser.session) {
      navigate(redirectTo);
    }
  }, [navigate, currentUser.session, redirectTo]);

  return <Outlet />;
};
